/**
 * The second line under a queued compilation's "Queued" status, from its place
 * in its camera's queue (`CompilationItem.queuePosition`).
 *
 * Display copy only: the row status stays `queued` either way. A job with no
 * position came from a server that predates the field, and has no second line.
 */
export function queuedStatusDetail(queuePosition: number | undefined): string | undefined {
  if (queuePosition === undefined) return undefined;
  if (queuePosition === 0) return "Waiting for device";
  return `Position ${String(queuePosition)}`;
}

/**
 * Whether a compilation can still be cancelled: only while it waits in the
 * cloud. Once sent, the device holds it and has no cancel command.
 */
export function isCancellable(item: { readonly status: string; readonly queuePosition?: number | undefined }): boolean {
  return item.status === "queued" && item.queuePosition !== undefined && item.queuePosition >= 1;
}
